import validadorDatas from './credenciamento-atualizacao-validador-datas'

class ValidarDadosGerais {
    validarAmparoLegal(licitacao){
        return !!(licitacao.amparoLegal && licitacao.idAmparoLegal);
    }

    validarPeriodoDataAberturaEDataFimProposta(licitacao) {
        return validadorDatas.validarAoPublicar(licitacao)
    }
}

export default new ValidarDadosGerais()
